import { render } from "./SharePhotoModal.vue?vue&type=template&id=25bc6166"
import script from "./SharePhotoModal.vue?vue&type=script&lang=js"
export * from "./SharePhotoModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Azize HRM\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__